/* eslint-disable @typescript-eslint/no-empty-function */
import { useNavigate } from 'react-router-dom'
import { CloseIcon } from 'assets/icons/CloseIcon'
import { DashboardCard, P } from 'styling/GlobalStyles'
import { IWidget } from 'types/dashboard.interface'
import { WidgetEditOverlay } from 'pages/Dashboard/Dashboard.styled'
import { WidgetHeader, WidgetTitle, WidgetDetailsLink } from './widgetParts.styled'
import { WidgetBody } from '../hrLayout.styled'
import { AttendanceDonut } from './AttendanceDonut'

export const AttendanceWidget = ({
  modalOpen,
  removeWidget,
  onDragOver,
  onDragStart,
  onDragDrop,
}: IWidget) => {
  const navigate = useNavigate()

  return (
    <DashboardCard
      draggable={modalOpen}
      onDragStartCapture={() => {
        onDragStart('attendance', 1)
      }}
      onDrop={onDragDrop}
      onDragEnd={(e) => {
        e.preventDefault()
      }}
      onDragOver={(e) => {
        e.preventDefault()
        onDragOver('attendance')
      }}
      width='1fr'
      style={{ gridArea: 'attendance', cursor: modalOpen ? 'grab' : 'normal' }}
    >
      {modalOpen && (
        <WidgetEditOverlay
          onClick={(e) => {
            removeWidget('attendance')
            e.stopPropagation()
          }}
        >
          <P>Remove Widget</P>
          <CloseIcon />
        </WidgetEditOverlay>
      )}
      <WidgetHeader>
        <WidgetTitle>Attendance</WidgetTitle>
        <WidgetDetailsLink
          type='button'
          disabled={modalOpen}
          onClick={(e) => {
            e.stopPropagation()
            if (!modalOpen) {
              navigate('/hr/attendance')
            }
          }}
        >
          Details ›
        </WidgetDetailsLink>
      </WidgetHeader>
      <WidgetBody>
        <AttendanceDonut />
      </WidgetBody>
    </DashboardCard>
  )
}
